// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * Module to handle feedback AJAX requests
 *
 * @module     mod_feedback/local/repository
 * @copyright  2024 Mikel Martín <mikel@moodle.com>
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

import Ajax from 'core/ajax';

/**
 * Reorder questions for a given feedback course module
 *
 * @param {Number} moduleId
 * @param {String} itemOrder
 * @return {Promise}
 */
export const reorderQuestions = (moduleId, itemOrder) => {
    const request = {
        methodname: 'mod_feedback_questions_reorder',
        args: {cmid: moduleId, itemorder: itemOrder}
    };

    return Ajax.call([request])[0];
};
